<template>
    <div>
        <div class="create-box">
            <div class="create-box-title">
                <h3>课程信息</h3>
            </div>
            <Form label-position="left" :label-width="110">
                <FormItem label="课程名称" class="form-item">
                    {{cur_course_info.course_name}}
                </FormItem>
                <FormItem label="创建时间" class="form-item">
                    {{ctime}}
                </FormItem>
                <FormItem label="课时数" class="form-item">
                    {{cur_course_info.course_hour}}
                </FormItem>
                <FormItem label="所属方向" class="form-item">
                    {{cur_course_info.direction_names ? cur_course_info.direction_names.join(',') : '无'}}
                </FormItem>
                <FormItem label="难度标签" class="form-item">
                    {{filter_course_type[cur_course_info.course_type]}}
                </FormItem>
                <FormItem label="学分" class="form-item">
                    {{cur_course_info.score}}
                </FormItem>
                <FormItem label="课程封面" class="form-item">
                    <img :src="cur_course_info.cover?cur_course_info.cover.path:''" style="width: 240px;height: 128px">
                </FormItem>
                <FormItem label="讲义教案" class="form-item" v-if="cur_course_info.course_datas">
                    <Table border
                           :columns="columns"
                           :data="cur_course_info.course_datas"
                           size="small"
                           width="600"
                    ></Table>
                </FormItem>
                <hr>
                <FormItem label="课程介绍" class="form-item">
                    {{cur_course_info.introduction}}
                </FormItem>
                <hr>
                <div class="create-box-title">
                    <h3>详细课程</h3>
                </div>
                <div class="exercises-list-box" v-if="cur_chapter_info.length>0">
                    <Collapse >
                        <Panel :name="item.title" v-for="(item,index) in cur_chapter_info" :key="item.id" >
                            {{index+1}}、{{item.name}}
                            <div slot="content" v-if="item.subsections">
                                <Collapse accordion v-for="(ite,idx) in item.subsections" :key="idx">
                                    <Panel :name="ite.name">
                                      {{ite.name}}
                                        <div v-if="ite.data" slot="content">
                                            <p  v-for="(it,i) in ite.data" :key="i">
                                                <a  class="collapse-a"
                                                    v-if="it.data_type ==2 || it.data_type ==3"
                                                    :href="it.fileurl"
                                                    target="_blank"
                                                    :data_id="it.data_id"
                                                >{{ it.filename }}</a>
                                                <a  class="collapse-a"
                                                    v-if="it.data_type ==1"
                                                    :data_id="it.data_id"
                                                    @click="lookAnnex(it)"
                                                >查看Markdown文件</a>
                                                <a class="collapse-a"
                                                   v-if="it.data_type ==5"
                                                   :data_id="it.data_id"
                                                   @click="lookAnnex(it)"
                                                >查看富文本文件</a>
                                                <a  class="collapse-a"
                                                    v-if="it.data_type ==4"
                                                    :href="it.link"
                                                    target="_blank"
                                                    :data_id="it.data_id"
                                                >{{it.link}}</a>
                                            </p>
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        </Panel>
                    </Collapse>
                </div>
                <hr>
            </Form>
            <div class="btn-box">
                <Button class="ml15" @click="cancel">取消</Button>
            </div>
        </div >
        <Modal
                v-model="previewModel"
                title="预览"
                :styles="{top: '10px'}"
                width="600">
            <div class="body-con" style="height: 500px;overflow-y: scroll">
                <VueMarkDown :source="document" v-if="dataType==1"></VueMarkDown>
                <ckeditor-view :content="document" v-if="dataType==5"></ckeditor-view>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import VueMarkDown from 'vue-markdown'
    import moment from 'moment'
    import ckeditorView from "../../../../components/ckeditor/ckeditorView"
    export default {
        name: "courseDetails",
        components: {
            VueMarkDown,
            ckeditorView
        },
        props:{
            course_id:Number
        },
        data() {
            return {
                value1:'1',
                questionType: '',
                previewModel:false,
                document:'',
                dataType:'',
                columns: [
                    {
                        title: '文件名',
                        key: 'name',
                        align: 'center',
                        tooltip:true
                    },
                    {
                        title: '大小',
                        key: 'size',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span',{
                                    style: {
                                        marginRight: '5px',
                                    }
                                },`${params.row.size}M`),
                            ]);
                        }
                    },
                    // {
                    //     title: '操作',
                    //     key: 'action',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         return h('div', [
                    //             h('a', {
                    //                 style: {
                    //                     marginRight: '5px',
                    //                     color: '#029ff6'
                    //                 },
                    //                 on: {
                    //                     click: () => {
                    //                         window.open(params.row.path)
                    //                     }
                    //                 }
                    //             }, '预览'),
                    //
                    //         ]);
                    //     }
                    // },
                    // {
                    //     title: '是否同步到资源广场',
                    //     key: 'is_open',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         return h('div', [
                    //             h('span',{
                    //                 style: {
                    //                     marginRight: '5px',
                    //                 }
                    //             },params.row.is_open == 1 ? '否':'是'),
                    //
                    //         ]);
                    //     }
                    // },
                ],
                filter_course_type: {
                    1: '基础',
                    2:'专业',
                    3:'核心',
                    4:'实训',
                }
            }
        },
        computed: {
            ...mapState({
                cur_course_info: state => state.courseManage.cur_course_info,
                cur_chapter_info:state => state.courseManage.cur_chapter_info
            }),
            ctime(state){
                return moment(state.cur_course_info.ctime).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        methods: {
            ...mapActions({
                getCurCourseInfo: 'courseManage/getCurCourseInfo',
                getChapter:'courseManage/getChapter',
            }),
            cancel(){
                this.$parent.course_details = false
            },
            //查看附件
            lookAnnex(item){
                if(item.data_type == 1 || item.data_type == 5){
                    this.previewModel = true;
                    this.dataType = item.data_type;
                    this.document = item.document
                }else{
                    this.dataType = '';
                }
                // this.getSubsection(id)
            }
        },
        mounted () {
            let _this = this
            this.getCurCourseInfo({course_id:_this.course_id,callback:res =>{}})
            this.getChapter({
                course_id:_this.course_id,
                callback:res =>{}
            })
        },
    }
</script>
<style lang="less">
    @import "../../../scenario/style/markdown";
    .create-box {
        .ivu-upload-list {
            display: inline-block;
            vertical-align: middle;
        }
    }

</style>
<style scoped lang="less">
    @import "../../style/index";
    .exercises-list-box {
        .collapse-a{
            color:#666;
        }
        .collapse-a:hover{
            color: #2D8cF0;
        }
    }
</style>
